import { FormControl, FormControlLabel, Radio, RadioGroup, TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useErrors } from '@/hooks/ErrorsStateContext'
import { useInputState } from '@/hooks/inputStateContext'
import React from 'react'

export default function RadioWithInputControl (props) {
  const { setting } = props
  const { paramaterName, pairWith, options = [], inputLabel, inputProps } = setting
  const [inputState, updateInputState] = useInputState()
  const [errors, setErrors] = useErrors()
  const classes = useStyles()

  const selectedValue = inputState[paramaterName]
  const pairValue = pairWith ? (inputState[pairWith] ?? '') : ''
  const pairError = pairWith ? errors[pairWith] : undefined

  const selectedOption = options.find((option) => option.value === selectedValue)
  const showPairInput = Boolean(pairWith && selectedOption?.showInput)

  const handleRadioChange = (e) => {
    const picked = options.find((option) => String(option.value) === e.target.value)
    const nextValue = picked ? picked.value : e.target.value
    updateInputState(paramaterName, nextValue)

    const clearedErrors = { [paramaterName]: undefined }
    if (pairWith && !picked?.showInput) {
      updateInputState(pairWith, '')
      clearedErrors[pairWith] = undefined
    }
    setErrors((prev) => ({ ...prev, ...clearedErrors }))
  }

  const handlePairChange = (e) => {
    updateInputState(pairWith, e.target.value)
    setErrors((prev) => ({ ...prev, [pairWith]: undefined }))
  }

  return (
    <FormControl variant='outlined' margin='dense' fullWidth>
      <div className={classes.row}>
        <RadioGroup
          row
          className={classes.radioGroup}
          name={paramaterName}
          value={selectedValue === undefined ? '' : String(selectedValue)}
          onChange={handleRadioChange}
        >
          {options.map((option) => (
            <FormControlLabel
              key={String(option.value)}
              value={String(option.value)}
              control={<Radio color='primary' size='small' />}
              label={option.label}
            />
          ))}
        </RadioGroup>
        {showPairInput && (
          <TextField
            className={classes.pairInput}
            label={inputLabel}
            required
            name={pairWith}
            type='text'
            variant='outlined'
            size='small'
            value={pairValue}
            onChange={handlePairChange}
            error={Boolean(pairError)}
            helperText={pairError}
            inputProps={inputProps}
          />
        )}
      </div>
    </FormControl>
  )
}

const useStyles = makeStyles(theme => ({
  // Headquarter / Branch No. radios 與 Branch No. 輸入框同一行（設計圖）
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  radioGroup: {
    flexShrink: 0,
    flexWrap: 'nowrap',
  },
  pairInput: {
    flex: 1,
    background: theme.palette.common.white,
  },
}))
